import React, { RefObject, useState } from 'react';
import styled from 'styled-components';
import { PrimaryButton, SecondaryButton } from '../../../../Button';
import Popover from '../../../../Popover';
import { InputField } from '../../../../Form';

interface IProps {
  anchorRef: RefObject<HTMLElement>;
  defaultName?: string;
  open: boolean;
  offset?: number;
  onChange: (name: string) => void;
  onClose: () => void;
}

const Container = styled.div`
  width: 264px;
  padding: 12px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 16px;
  margin-top: 16px;
`;

export default ({
  anchorRef,
  defaultName = '',
  open,
  offset,
  onChange,
  onClose,
}: IProps) => {
  const [name, setName] = useState(defaultName);

  const handleSubmit = () => {
    onChange(name);
    onClose();
  };
  const handleReset = () => {
    setName('');
  };

  return (
    <Popover
      isOpen={open}
      close={onClose}
      anchor={anchorRef.current}
      anchorOrigin={{ vertical: 'top', horizontal: offset ?? 'right' }}
    >
      <Container>
        <InputField
          autoFocus
          placeholder={'Rename bin'}
          value={name}
          onChange={setName}
        />
        <Footer>
          <SecondaryButton
            type="button"
            onClick={handleReset}
            trackContext="binning rename"
            trackAction="reset"
          >
            Reset
          </SecondaryButton>
          <PrimaryButton
            type="button"
            onClick={handleSubmit}
            trackContext="binning rename"
            trackAction="confirm"
          >
            Confirm
          </PrimaryButton>
        </Footer>
      </Container>
    </Popover>
  );
};
